// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3gXSF","log":"ModalInventoryLogs_log__3UKCN","date":"ModalInventoryLogs_date__3cl_B","userName":"ModalInventoryLogs_userName__2aEgE"};